/**
 * Icone SVG anteprima widget Price Alert (dashboard).
 *
 * Accoppiamento obbligatorio: stesso ordine di chiavi e stessi path di
 * `trait-price-alert.php` → `carthub_pa_icon_svg_markup()` sul plugin WordPress.
 * Aggiungere un’icona = aggiornare entrambi i file nella stessa release.
 */
export const PRICE_ALERT_ICON_KEYS = ["bell", "tag", "trend_down", "mail", "percent", "sparkle"];

const common = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

/** Anteprima compatta nel form / card mockup widget */
export function PriceAlertWidgetIconPreview({ iconKey, size = 24 }) {
  const p = { ...common, width: size, height: size, "aria-hidden": true };
  switch (iconKey) {
    case "bell":
      return (
        <svg {...p}>
          <path d="M18 8A6 6 0 1 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
      );
    case "tag":
      return (
        <svg {...p}>
          <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a1 1 0 0 0-1 1v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.43 0l6.58-6.58a2.426 2.426 0 0 0 0-3.43z" />
          <circle cx="7.5" cy="7.5" r=".5" fill="currentColor" stroke="none" />
        </svg>
      );
    case "trend_down":
      return (
        <svg {...p}>
          <polyline points="23 18 13.5 8.5 8.5 13.5 1 6" />
          <polyline points="17 18 23 18 23 12" />
        </svg>
      );
    case "mail":
      return (
        <svg {...p}>
          <rect width="20" height="16" x="2" y="4" rx="2" />
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
        </svg>
      );
    case "percent":
      return (
        <svg {...p}>
          <line x1="19" x2="5" y1="5" y2="19" />
          <circle cx="6.5" cy="6.5" r="2.5" />
          <circle cx="17.5" cy="17.5" r="2.5" />
        </svg>
      );
    case "sparkle":
      return (
        <svg {...p}>
          <path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3L12 3Z" />
        </svg>
      );
    default:
      return null;
  }
}
